import { FC } from 'react';
import { useQuery } from '@apollo/client';
import { Collapse, Stack } from '@chakra-ui/react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import Text from 'components/_core/Text';

import { Transfer } from '../../../../types';
import { BankTransferRecipientDocument } from './hooks/useGetBankTransferRecipientName/getBankTransferRecipient.gql';
import locales from './locales';

interface RecipientNameDiffersWarningBoxProps {
  bankTransferRecipientId: Transfer['bankTransferRecipient']['bankTransferRecipientId'];
}
const RecipientNameDiffersWarningBox: FC<
  RecipientNameDiffersWarningBoxProps
> = ({ bankTransferRecipientId }) => {
  const { companyProfileId } = useCompanyContext();
  const { data, error, loading } = useQuery(BankTransferRecipientDocument, {
    skip: !bankTransferRecipientId || !companyProfileId,
    variables: {
      bankTransferRecipientId: bankTransferRecipientId!, // eslint-disable-line @typescript-eslint/no-non-null-assertion
      companyProfileId: companyProfileId!, // eslint-disable-line @typescript-eslint/no-non-null-assertion
    },
  });

  if (!bankTransferRecipientId || !companyProfileId) {
    return null;
  }

  const recipientName = data?.viewer.company.bankTransferRecipient.name ?? '';

  return (
    <Collapse in={!loading && !error}>
      <Stack bg="orange.-2-bg" borderRadius="radius-8" padding="space-16">
        <Text
          color="orange.-2"
          fontWeight="weight-500"
          size="sm"
          variant="primary"
        >
          {locales.warningTitle}
        </Text>
        <Text color="orange.-2" size="sm" variant="primary">
          {locales.formatString(locales.warningMessage, recipientName)}
          <br />
          {locales.warningHelp}
        </Text>
      </Stack>
    </Collapse>
  );
};

export default RecipientNameDiffersWarningBox;
